import React from 'react';
import { Header } from './Header';
import { Footer } from './Footer';
import { WhatsAppButton } from './WhatsAppButton';
interface LayoutProps {
  children: React.ReactNode;
}
export function Layout({
  children
}: LayoutProps) {
  return <div className="flex flex-col min-h-screen" data-id="element-153">
      <Header data-id="element-154" />
      <main className="flex-grow pt-[104px] lg:pt-[116px]" data-id="element-155">{children}</main>
      <Footer data-id="element-156" />
      <WhatsAppButton data-id="element-157" />
    </div>;
}